import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Card,
  CardActionArea,
  CardContent,
} from '@mui/material';
import { toast } from 'react-hot-toast';
import TextField from '@mui/material/TextField';
import React, { useEffect, useState } from 'react';

import {
  IInitialState,
  AccionDetalle,
  TipoAccionDetalle,
} from '../../Shared/data/FormReducer';
import Stepper from '../shared/Forms/Stepper';
import ToastDisplay from '../../Utils/ToastDisplay';
import FormPorcentajeGrasa from './FormPorcentajeGrasa';
import ModalCambiarObjetivo from './ModalCambiarObjetivo';
import FormVideos from '../ModalEvaluacion/EvaluacionComponents/FormVideos';

import perdergrasaHombreS from '../../Shared/Images/icono_grasa_hombre_2_amarillo.png';
import perdergrasaMujerS from '../../Shared/Images/icono_grasa_mujer_2_amarillo.png';
import musculacionHombreS from '../../Shared/Images/icono_musculo_hombre_2_amarillo.png';
import musculacionMujerS from '../../Shared/Images/icono_musculo_mujer_2_amarillo.png';
import perdergrasaHombre from '../../Shared/Images/icono_grasa_hombre_2.png';
import perdergrasaMujer from '../../Shared/Images/icono_grasa_mujer_2.png';
import musculacionHombre from '../../Shared/Images/icono_musculo_hombre_2.png';
import musculacionMujer from '../../Shared/Images/icono_musculo_mujer_2.png';


interface Props {
  state: IInitialState;
  dispatch: React.Dispatch<AccionDetalle>;
}

const Form04 = ({state, dispatch} : Props) => {

  const [isOpenModalCambiarObjetivo, setIsOpenModalCambiarObjetivo] = useState<boolean>(false);
  const [isContinue, setIsContinue] = useState<boolean>(false)

  const handleItem = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    tipo: string,
  ) => {
    dispatch({
      type:
        tipo === 'peso'
          ? TipoAccionDetalle.CHANGE_PESO
          : tipo === 'porcentajeGrasa'
          ? TipoAccionDetalle.CHANGE_PORCENTAJEGRASA
          : TipoAccionDetalle.CHANGE_UNIDADPESO,
      payload: e.target.value,
    });

    dispatch({
      type:
        tipo === 'peso'
          ? TipoAccionDetalle.CHANGE_VALPESO
          : TipoAccionDetalle.CHANGE_VALPGRASA,
      payload: false,
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleNext = () => {
    let error1 = false; // peso
    let error2 = false; // %grasa
    let error3 = false; // unidad de peso


    if (state.objetivo === 'null') {
      return toast.error(
        <ToastDisplay title={`Hubo un error`} message={'Seleccione un objetivo'} />,
      );
    }
    if (
      (state.peso < 40 && state.unidadPeso === 'Kg') ||
      (state.peso < 88 && state.unidadPeso === 'Lb')
    ) {
      return toast.error(
        <ToastDisplay
          title={`Hubo un error`}
          message={`Tu peso no puede ser menor a ${
            state.unidadPeso === 'Kg' ? '40 kg' : '88 libras'
          }`}
        />,
      );
    }
    if (
      (state.peso > 200 && state.unidadPeso === 'Kg') ||
      (state.peso > 440 && state.unidadPeso === 'Lb')
    ) {
      return toast.error(
        <ToastDisplay
          title={`Hubo un error`}
          message={`Tu peso no puede ser mayor a ${
            state.unidadPeso === 'Kg' ? '200 kg' : '440 libras'
          }`}
        />,
      );
    }

    if (state.porcentajeGrasa < 5 || state.porcentajeGrasa > 50) {
      return toast.error(
        <ToastDisplay
          title={`Hubo un error`}
          message={`Tu porcentaje de grasa debe estar entre 5% y 50%`}
        />,
      );
    }
    if( state.porcentajeGrasa >= 25 && state.objetivo === 'MM' ) {
      if(!isContinue){
        setIsOpenModalCambiarObjetivo(true);
        return;
      }
    }

    if (state.peso === 0) {
      dispatch({
        type: TipoAccionDetalle.CHANGE_VALPESO,
        payload: true,
      });
      error1 = true;
    }
    if (state.porcentajeGrasa === 0) {
      dispatch({
        type: TipoAccionDetalle.CHANGE_VALPGRASA,
        payload: true,
      });
      error2 = true;
    }
    if (state.unidadPeso === '') error3 = false;
    if (!error1 && !error2 && !error3) {
      window.scrollTo(0, 0);
      dispatch({
        type: TipoAccionDetalle.CHANGE_NFORM,
        payload: state.nForm + 1,
      });
    }
    if (error1 || error2 || error3) {
      if (error1 && error2) {
        toast.error(
          <ToastDisplay
            title={`Hubo un error`}
            message={'Marca la unidad peso y porcentaje de grasa antes de continuar.'}
          />,
        );
      } else if (error1 && !error2 && !error3) {
        toast.error(
          <ToastDisplay
            title={`Hubo un error`}
            message={'Completa tu peso antes de continuar.'}
          />,
        );
      } else if (!error1 && error2 && !error3) {
        toast.error(
          <ToastDisplay
            title={`Hubo un error`}
            message={'Completa tu porcentaje de grasa antes de continuar.'}
          />,
        );
      } else if (!error1 && !error2 && error3) {
        toast.error(
          <ToastDisplay title={`Hubo un error`} message={'Selecciona unidad de peso.'} />,
        );
      } else if (error1 && error2 && !error3) {
        toast.error(
          <ToastDisplay
            title={`Hubo un error`}
            message={'Completa tu peso y porcentaje de grasa antes de continuar.'}
          />,
        );
      }
      error1 = false;
      error2 = false;
      error3 = false;
    }
  };

  return (
    <div className="mb-3 container flex flex-column justify-content-center">

      <FormVideos 
        url='https://player.vimeo.com/external/1048027717.m3u8?s=1a2e3c4cc5f7848777cf16f371288002ae861fd0&logging=false'
      />

      <h2 className="title text-center">¿Cuánto pesas?</h2>
      <div className="row flex justify-content-center mb-8">
        <div className="col-12 col-md-12 flex justify-content-center">
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="female"
              name="radio-buttons-group"
              value={state.unidadPeso}
              onChange={(e) => handleItem(e, 'uPeso')}
            >
              <FormControlLabel value="Kg" control={<Radio />} label="Kilogramos" />
              <FormControlLabel value="Lb" control={<Radio />} label="Libras" />
            </RadioGroup>
          </FormControl>
        </div>
        {(state.unidadPeso === 'Kg' || state.unidadPeso === 'Lb') && (
          <div className="col-12 col-md-3 mb-1">
            <TextField
              error={state.valPeso}
              id="peso"
              type="number"
              label="Peso"
              variant="standard"
              value={state.peso === 0 ? '' : state.peso}
              onChange={(e) => handleItem(e, 'peso')}
              fullWidth
              inputProps={{ min: 0 }}
            />
          </div>
        )}
      </div>
        
      <FormPorcentajeGrasa 
        dispatch={dispatch}
        state={state}
      />

      <div className="container form-macro mb-8 mt-2">
        <section id="form4">
          <div className="text-center mb-4">
            <h2 style={{ fontWeight: '700' }} className="title">
              ¿Cuál es tu objetivo?
            </h2>
            <p className="text-slate-500">Seleccione una opción</p>
          </div>
          <div className="sm:m-0 text-center flex  justify-center gap-2 md:gap-8  md:m-auto">
            <div className="">
              <Card
                sx={{
                  border: state.objetivo === 'MM' ? 0 : 0,
                  opacity: state.objetivo === 'MM' ? '1' : '0.4',
                  boxShadow: 'none',
                }}
              >
                <CardActionArea
                  onClick={() =>
                    dispatch({
                      type: TipoAccionDetalle.CHANGE_OBJETIVO,
                      payload: 'MM',
                    })
                  }
                >
                  <CardContent>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <img
                        src={
                          state.sexo
                            ? state.objetivo === 'MM'
                              ? musculacionHombreS
                              : musculacionHombre
                            : state.objetivo === 'MM'
                            ? musculacionMujerS
                            : musculacionMujer
                        }
                        alt="ImagenMusculacion"
                        className=" w-[100px] md:w-[150px]"
                      />
                    </div>
                  </CardContent>
                </CardActionArea>
              </Card>
              <h5 className="m-0 text-base" style={{ fontWeight: '700' }}>
                Masa Muscular
              </h5>
            </div>
            <div className="">
              <Card
                sx={{
                  border: state.objetivo === 'PG' ? 0 : 0,
                  opacity: state.objetivo === 'PG' ? '1' : '0.4',
                  boxShadow: 'none',
                }}
              >
                <CardActionArea
                  onClick={() =>
                    dispatch({
                      type: TipoAccionDetalle.CHANGE_OBJETIVO,
                      payload: 'PG',
                    })
                  }
                >
                  <CardContent>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <img
                        src={
                          state.sexo
                            ? state.objetivo === 'PG'
                              ? perdergrasaHombreS
                              : perdergrasaHombre
                            : state.objetivo === 'PG'
                            ? perdergrasaMujerS
                            : perdergrasaMujer
                        }
                        className="w-[100px] md:w-[150px]"
                        alt="ImagenPerderGrasa"
                      />
                    </div>
                  </CardContent>
                </CardActionArea>
              </Card>
              <h5 className="m-0 text-base" style={{ fontWeight: '700' }}>
                Perder Grasa
              </h5>
            </div>
          </div>
        </section>
      </div>

      { isOpenModalCambiarObjetivo && (
        <ModalCambiarObjetivo 
          isOpen={isOpenModalCambiarObjetivo}
          setIsOpen={setIsOpenModalCambiarObjetivo}
          setIsContinue={ setIsContinue }
        />
      )}

      <Stepper
        state={state}
        dispatch={dispatch}
        handleNext={handleNext}
        mostrarAdvertencia
      />
    </div>
  );
};

export default Form04;
